import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { Card, CardContent } from './ui/card';
import { CONTACT_INFO } from '../constants/clinicData';
import { useTranslation } from 'react-i18next';

const LocationSection = () => {
  const { t } = useTranslation();
  const sectionRef = useScrollReveal();

  return (
    <section id="location" className="py-20 px-4 bg-slate-50" ref={sectionRef}>
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 text-center scroll-reveal">
          {t('location.title')}
        </h2>
        <div className="w-20 h-1 mx-auto mb-12 scroll-reveal" style={{ backgroundColor: 'var(--medical-primary)', animationDelay: '0.1s' }}></div>

        <div className="grid md:grid-cols-2 gap-8">
          <Card className="scroll-reveal-scale border-0 shadow-lg" style={{ animationDelay: '0.2s' }}>
            <CardContent className="pt-6">
              <h3 className="text-xl font-semibold text-slate-900 mb-6">{t('location.contactInfo')}</h3>
              <div className="space-y-4">
                {CONTACT_INFO.map((info) => {
                  const Icon = info.icon;
                  return (
                    <div key={info.labelKey} className="flex items-start gap-4 transition-transform duration-300 hover:translate-x-2">
                      <div className="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center" 
                        style={{ 
                          background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)'
                        }}
                      >
                        <Icon style={{ color: 'var(--medical-primary)' }} size={20} />
                      </div>
                      <div>
                        <p className="text-sm text-slate-600 mb-1">{t(`location.${info.labelKey}`)}</p>
                        {info.link ? (
                          <a
                            href={info.link}
                            target={info.link.startsWith('http') ? '_blank' : undefined}
                            rel={info.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                            className="font-medium text-slate-900 transition-colors hover:underline"
                            onMouseEnter={(e) => e.currentTarget.style.color = 'var(--medical-primary)'}
                            onMouseLeave={(e) => e.currentTarget.style.color = ''}
                          >
                            {t(`location.${info.valueKey}`)}
                          </a>
                        ) : (
                          <p className="font-medium text-slate-900">{t(`location.${info.valueKey}`)}</p>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </CardContent>
          </Card>

          <div className="scroll-reveal-scale" style={{ animationDelay: '0.35s' }}>
            <div className="rounded-lg overflow-hidden shadow-lg h-full min-h-[400px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3749.8030363323396!2d79.29686711114793!3d19.974783881346266!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd2d50af683d753%3A0x1363b171f49819c1!2sTonge%20Healthcare%20%7C%20Dr.%20Nikhil%20Tonge%20%7C%20MBBS%20MD%20Medicine!5e0!3m2!1sen!2sin!4v1777577849166!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: '400px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Tonge Healthcare Location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;